import React, { useEffect } from "react";
import "./Myaccountpage.css";
import UserAdministrationdetails from "../../components/Reuseablecomponents/Details/UserAdministrationdetails/UserAdministrationdetails";
import Securitydetails from "../../components/Reuseablecomponents/Details/Securitydetails/Securitydetails";
import Companydetails from "../../components/Reuseablecomponents/Details/Companydetails/Companydetails";
import Billingdetails from "../../components/Reuseablecomponents/Details/Billingdetails/Billingdetails";
// import { useDispatch, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// import { AppDispatch, RootState } from "../../Store";
import { AppDispatch } from "../../Store";
import { fetchuserprofiledata } from "./Myaccountmatchesslice";

export default function Myaccountpage() {

    const token: any = localStorage.getItem("user")
    // const Userprofiledata = useSelector((state: RootState) => state.Userprofiledata.Userprofiledata)

    const dispatch: AppDispatch = useDispatch()

    useEffect(() => {
        if (token !== null && token !== undefined) {
            dispatch(fetchuserprofiledata(JSON.parse(token)))
        }
        window.scrollTo(0, 0)
    }, [])

    return (
        <>

            {/* Create an account page start */}

            <div className="createaccountpage_container">
                <div className="row m-0">
                    <div className="col-md-3 createaccountpage_sidenav">

                        <h3 className="createaccountpage_sidenav_header">
                            Account Overview
                        </h3>

                        <p className="createaccountpage_sidenav_text">
                            Home/ Account
                        </p>

                        <ul className="nav nav-tabs flex-column" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="company-tab" data-bs-toggle="tab" data-bs-target="#company" type="button" role="tab" aria-controls="company" aria-selected="true">
                                    Company
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link " id="billing-tab" data-bs-toggle="tab" data-bs-target="#billing" type="button" role="tab" aria-controls="billing" aria-selected="false">
                                    Billing
                                </button>
                            </li>

                            <li className="nav-item" role="presentation">
                                <button className="nav-link " id="useradministration-tab" data-bs-toggle="tab" data-bs-target="#useradministration" type="button" role="tab" aria-controls="useradministration" aria-selected="false">
                                    User Administration
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="security-tab" data-bs-toggle="tab" data-bs-target="#security" type="button" role="tab" aria-controls="security" aria-selected="false">
                                    Security
                                </button>
                            </li>

                        </ul>
                    </div>
                    <div className="col-md-9 p-0">
                        <div className="createaccountpage_content">
                            <div className="tab-content" id="myTabContent">

                                <div className="tab-pane fade active show" id="company" role="tabpanel" aria-labelledby="company-tab">
                                    <Companydetails />
                                </div>
                                <div className="tab-pane fade billing_informaion " id="billing" role="tabpanel" aria-labelledby="billing-tab">
                                    <Billingdetails />
                                </div>
                                <div className="tab-pane fade " id="useradministration" role="tabpanel" aria-labelledby="useradministration-tab">
                                    <UserAdministrationdetails />
                                </div>
                                <div className="tab-pane fade security_information" id="security" role="tabpanel" aria-labelledby="security-tab">
                                    <Securitydetails />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Create an account page over */}

        </>
    )

}